import React from "react";
import { shape, string, arrayOf, oneOf, bool } from "prop-types";
// eslint-disable-next-line import/no-cycle
import { CollapsibleLinksList as CollapsibleLinksListComponent } from "../../sharedComponents/CollapsibleLinksList";
import * as styles from "./CollapsibleLinksList.module.scss";

const defaultLabels = {
	allCategories: "All Categories",
};

const CollapsibleLinksList = ({
	listHeading,
	linksGroup,
	variant,
	noToggle,
	expanded,
	labels: providedLabels,
}) => {
	const labels = { ...defaultLabels, ...providedLabels };

	return (
		<CollapsibleLinksListComponent
			listHeading={listHeading}
			linksGroup={linksGroup}
			customStyles={styles}
			variant={variant}
			noToggle={noToggle}
			expanded={expanded}
			labels={labels}
		/>
	);
};

CollapsibleLinksList.propTypes = {
	listHeading: string.isRequired,
	variant: oneOf(["classic", "simple"]),
	noToggle: bool,
	linksGroup: arrayOf(
		shape({
			id: string,
			title: string,
			sectionLink: string,
			entries: arrayOf(
				shape({
					id: string,
					linkText: string,
					url: string,
					target: string,
				})
			),
		})
	),
	expanded: bool,
	labels: shape({ allCategories: string }),
};
CollapsibleLinksList.defaultProps = {
	noToggle: null,
	linksGroup: [],
	variant: null,
	expanded: true,
	labels: defaultLabels,
};

export default CollapsibleLinksList;
export { CollapsibleLinksList };
